<template>
  <div class="couponDiscountPage">
      <XR-head titleText="优惠券" ref="headObj"></XR-head>
      <mu-tabs :value="activeTab" @change="handleTabChange">
        <mu-tab value="tab1" :title="'可用优惠券'"/>
        <mu-tab value="tab2" :title="'不可用优惠券'"/>
      </mu-tabs>
      <div v-if="activeTab === 'tab1'">
       <div class="coupon_sec_body">
          <div v-for="couponRow in navList" :key="couponRow.id" class="coupon_default_inner">   
            <template v-if="couponRow.useType==1"> 
               <div class="chk">
                <mu-checkbox class="cart-chk" :nativeValue="couponRow.id" v-model="checkList"  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
              </div>
              <div :class="(couponRow.value>=100 ? 'couponGrey' : (couponRow.type=='平台券'? 'couponRink':'couponYellow'))" class="couponLeft"  :style="{backgroundImage: 'url(' + (couponRow.value>=100 ? bg2 : (couponRow.type=='平台券'? bg1:bg3)) + ')'}">
                  <div class="coupon_discount" >
                      <p class="cost">￥</p>
                      <p class="money">{{couponRow.discount}}</p>
                  </div>
              </div>
              <div class="couponRight" :class="(couponRow.value>=100 ? 'couponGrey' : (couponRow.type=='平台券'? 'couponRink':'couponYellow'))">              
                <div class="coupon_content" :style="{width:couponWidth+'px'}">
                  <p class="coupon_title">
                    <span class="coupon_type">{{couponRow.type}}</span> {{couponRow.name}}
                  </p>
                  <p class="limit">
                      使用门槛：满{{couponRow.allPrice}}元可用
                  </p>
                  <div class="coupon_progress">
                      使用时间：{{couponRow.date}}
                  </div>                 
                </div>
              </div>            
            </template>
          </div>
           <div class="bottom-bar">
              <div class="cart-all-chk">            
                <mu-checkbox label="全选" @change="checkAll()" v-model="checkAllState" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
              </div>
              <mu-row >
                <mu-col width="65" tablet="65" desktop="65">
                    <p class="cart-total">
                      <span class="text">共</span>
                      <span class="money">{{totalCount}}</span>
                      <span>张优惠券，优惠</span> 
                      <span class="text"><i class="fa fa-rmb"></i></span>
                      <span class="money">{{price}}元</span>
                    </p>
                </mu-col> 
                <mu-col width="35" tablet="35" desktop="35" >
                  <mu-flat-button @click="GoHistory()" label="确定" class="gobuy" backgroundColor="red" color="white" fullWidth />
                </mu-col>
                            
              </mu-row>
            </div>
          </div>
      </div>
     
      <div v-if="activeTab === 'tab2'">
        <div class="coupon_sec_body">           
            <div v-for="couponRow in navList" :key="couponRow.id" class="coupon_default_inner">  
              <template v-if="couponRow.useType==2">  
                <div class="couponGrey couponLeft"  :style="{backgroundImage: 'url(' +bg2+ ')'}">
                    <div class="coupon_discount" >
                        <p class="cost">￥</p>
                        <p class="money">{{couponRow.discount}}</p>
                    </div>
                </div>
                <div class="couponRight couponGrey" >              
                  <div class="coupon_content" :style="{width:couponWidth2+'px'}">
                    <p class="coupon_title">
                      <span class="coupon_type">{{couponRow.type}}</span> {{couponRow.name}}
                    </p>
                    <p class="limit">
                        使用门槛：满{{couponRow.allPrice}}元可用
                    </p>
                    <div class="coupon_progress">
                      不可用原因: 不属于当前店铺产品
                    </div>                 
                  </div>
                </div>  
              </template>        
            </div>     
          </div> 
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      activeTab: 'tab1',
      ulWidth: document.documentElement.clientWidth-99,
      price: 0,
      totalCount:0,
      checkList: [],
      checkAllState:false,
      idList:[],
      bg1:'../../../../static/coupon/couponCenter1.png',
      bg2:'../../../../static/coupon/couponCenter1-2.png',
      bg3:'../../../../static/coupon/couponCenter1-3.png',
      couponWidth: document.documentElement.clientWidth-20-60-16-40,
      couponWidth2: document.documentElement.clientWidth-20-60-16,
      navList:[
          {
            name:"商城自营食品类使用",
            id:0,
            allPrice:300,
            discount:60,
            type:'平台券', 
            value:100,
            date:'2018.01.01-2019.01.01',
            useType:2,
          },
          {
            name:"商城自营食品类使用",
            id:1,
            allPrice:300,
            discount:80,
            type:'店铺券',
            value:60,
            date:'2018.01.01-2019.01.01',
            useType:1,
          },
          {
            name:"商城自营食品类使用",
            id:2,
            allPrice:300,
            discount:60,
            type:'平台券', 
            value:50,
            date:'2018.01.01-2019.01.01',
            useType:2,
          },
           {
            name:"商城自营食品类使用",
            id:3,
            allPrice:300,
            discount:100,
            type:'平台券', 
            value:50,
            date:'2018.01.01-2019.01.01',
            useType:1,
          },
          {
            name:"商城自营食品类使用",
            id:4,
            allPrice:300,
            discount:1000,
            type:'平台券',
            date:'2018.01.01-2019.01.01',
            value:50,
            useType:1,
          }, 
      ],
    }
  },
  mounted:function(){   
    for(var i=0;i<this.navList.length;i++){
      if(this.navList[i].useType!=2){
        this.idList.push(this.navList[i].id)
      }   
    } 
    this.checkAll()
    
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    checkAll(){ 
      if(!this.checkAllState){
        this.checkList= this.idList    
      }
      else{
        this.checkList =[]
      }
    },
    btnClick(num){
      this.navList[this.ins].Childrens[num].state='已领取'
    },
    handleTabChange (val) {
        this.activeTab = val
      },
    getPriceTotal(){
      this.price=0
      for(var i=0;i<this.checkList.length;i++){
        this.price= this.price+this.navList[this.checkList[i]].discount
      }
    },

  },
  watch:{
    checkList(){
      if(this.checkList.length){
        if(this.checkList.length != this.idList.length){
          this.checkAllState = false
        }else{
          this.checkAllState = true
        }
        this.totalCount = this.checkList.length
        this.getPriceTotal()
        
      }
      else{
        this.totalCount = 0
        this.price=0
      }    
    }
  }
}
</script>
<style>
  .couponDiscountPage{
    margin: 0;
  }
  .couponDiscountPage .mu-tabs{
    background: #fff;
  }
  .couponDiscountPage .mu-tabs .mu-tab-text{
    color: #000;
  }
  .couponDiscountPage .xr-pageTip{
    padding: 0;
    margin-top: 100px;
  }
  .couponDiscountPage .coupon_center_v2_nav{
    position: relative;
    overflow: hidden;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav{
    overflow: auto;
    background: #fff;
    height: 45px;
    padding-left: 64px;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav li{
    list-style: none;
    display: inline-block;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav li:first-child{
    position: absolute;
    left: 0;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav li.active .mu-flat-button .mu-flat-button-label{
    border-bottom: 2px solid red;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav .hold{
    float: left;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav li .mu-flat-button{
    min-width: 64px;
    height: 45px;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav li .mu-flat-button .mu-flat-button-label{
    line-height: 45px;
    height: 45px;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav ul{
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    overflow-x: auto;
    float: left;
  }
  .couponDiscountPage .coupon_center_v2_nav .nav ul::-webkit-scrollbar {
    display: none;
  }
  .couponDiscountPage .coupon_banner_bg{
    width: 100%;
  }
  .couponDiscountPage .coupon_banner_bg img{
    width: 100%;
    display: block;
  }
  .couponDiscountPage .coupon_sec_body{
    width: 100%;
    padding: 0 10px;
    margin-bottom: 56px;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner{
    width: 100%;
    display: flex;
    margin-top: 10px;
    background-size: 100% 100%; 
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponLeft{
    padding: 10px 0;
    background-size:100% 100%; 
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponLeft .coupon_discount{
    width: 60px;
    height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    margin: 0 8px;
    margin-top: 8px;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
    background: #999;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponLeft.couponRink .coupon_discount{
    background: #E95E88;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
    background: orange;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .coupon_discount .cost{
    height: 20px;
    line-height: 30px;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .coupon_discount .money{
    font-size: 26px;
    height: 30px;
    line-height: 30px;
  }  
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight{
    background-image: url('../../../../static/coupon/couponCenter2.png'); 
    background-size:100% 100%; 
    padding: 10px 0;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content{
    padding: 0 8px;
    border-left: 1px dotted #999;
    
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 25px;
    line-height: 23px;
    font-size: 16px;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
    padding: 2px 5px;
    font-size: 12px;
    border-radius: 3px
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
    border: 1px solid #999;
    color: #999;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
    border: 1px solid #E95E88;
    color: #E95E88;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
    border: 1px solid orange;
    color: orange;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .limit{
    font-size: 12px;
    color: #666;
    margin: 5px 0 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .coupon_progress{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .couponDiscountPage .coupon_sec_body .coupon_default_inner .chk{
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
  }
  .couponDiscountPage .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
  }
  .couponDiscountPage .bottom-bar .cart-all-chk{
    float: left;
    width: 25%;
    text-align: left;
    height: 24px;
    text-align: center;
    margin: 16px 0;
  }
  .couponDiscountPage .bottom-bar .cart-total{
    float: left;
    height: 56px;
    line-height: 56px;
    font-size: 12px;
  }
  .couponDiscountPage .bottom-bar .cart-total .text .fa{
    color:red;
  }
  .couponDiscountPage .bottom-bar .cart-total .money{
    color:Red;
  }
  .couponDiscountPage .gobuy{
    width: 100%;
    line-height: 56px;
    height: 56px;
    text-align: center;
  }
  .couponDiscountPage .no-gutter .desktop-65 .operatorBtn:nth-child(2){
    margin-left:5%; 
  }
  .couponDiscountPage .bottom-bar .operatorBtn{
    float: left;
    width: 35%;
    height: 56px;
    line-height: 56px;
    font-size: 12px;
  }
  .couponDiscountPage .col-65{
    display: flex;
  }
</style>


// WEBPACK FOOTER //
// src/pages/retail/coupon/couponDiscount.vue